<template>
  <div :class="{ 'is-invalid': showValidationError }">
    <div class="form-check">
      <input :id="checkboxId" type="checkbox" :class="['form-check-input', {'is-invalid': showValidationError}]" :checked="initialValue"
             :name="inputName" @change="onChange">
      <label v-if="showLabel" class="form-check-label" :for="checkboxId">
        <slot name="label">
          <required v-if="required" />
          <span v-html="label" />
        </slot>
      </label>
    </div>

    <validation-errors v-if="showValidationError" :errors="validationErrors" />

    <p v-if="hint" class="form-text text-muted">
      {{ hint }}
    </p>
  </div>
</template>

<script>
import Required from '../required'
import ValidationErrors from './validation-errors'

export default {
  components: { Required, ValidationErrors },

  props: {
    checkboxId: {
      type: String,
      required: true
    },

    hint: {
      type: String,
      required: false
    },

    initialValue: {
      type: Boolean,
      required: false,
      default: false
    },

    inputName: {
      type: String,
      required: true
    },

    label: {
      type: String,
      required: false
    },

    required: {
      type: Boolean,
      required: false,
      default: false
    },

    showLabel: {
      type: Boolean,
      required: false,
      default: true
    },

    validationErrors: {
      type: Array,
      required: false
    }
  },

  emits: ['change'],

  computed: {
    showValidationError() {
      return this.validationErrors && this.validationErrors.length > 0
    }
  },

  methods: {
    onChange({target}) {
      this.$emit('change', target.checked)
    }
  }
}
</script>
